import baseTheme from './StyledTheme';
import purviewIconsV2 from '../../../purview-design/src/refs/Icons.tsx'
import { desaturate, lighten, darken } from 'polished';

const purviewIconsV2LegacyAliases = Object.entries(purviewIconsV2).reduce((acc, [iconName, glyph]) => {
  if (iconName.startsWith('icon-')) {
    acc[iconName.slice(5)] = glyph;
  }
  return acc;
}, {});


export const createCustomColorTheme = (customColors) => {
  const main    = customColors?.main    || '#008bd2';
  const aiMain  = customColors?.aiPanelMainColor || customColors?.main  || '#008dd0';
   
  return {
    ...baseTheme,
    colors: {
      ...baseTheme.colors,
      gray220: '#e5e5e5',
      main,
      secondary: customColors?.secondary || '#1F70A0',
      mainBlue: '#008bd2',
      relevanceBarColor: customColors?.relevanceBarColor || '#3AB8F3',

      // ── Highlight / selection accent (e.g. dropdown active item) ────
      highlightColor: customColors?.highlightColor || '#25a9e1',

      // ── Table / list alternating row background ──────────────────────
      backgroundRowColor: customColors?.backgroundRowColor || desaturate(0.65, lighten(0.545, main)),

      // ── Sidebar selected item background ─────────────────────────────
      sidebarSelectedColor: customColors?.sidebarSelectedColor || desaturate(0.6, lighten(0.52, main)),

      // ── Case note card background ────────────────────────────────────
      noteCardBg: customColors?.noteCardBg || desaturate(0.6, lighten(0.525, main)),

      // ── Medical record card derived tones ────────────────────────────
      recordCardBg:       customColors?.recordCardBg       || desaturate(0.65,  lighten(0.545, main)),
      recordDetailsBg:    customColors?.recordDetailsBg    || desaturate(0.667, lighten(0.541, main)),
      recordDragHandleBg: customColors?.recordDragHandleBg || desaturate(0.53,  lighten(0.52,  main)),

      // ── AI panel / chat / source-link derived tones ──────────────────
      // Single overridable entry-point; everything else derives from it.
      aiPanelMainColor: aiMain,

      // Interactive accents
      aiPanelShadow:    customColors?.aiPanelShadow    || darken(0.076, aiMain),                           // #0072a9  darker hover/active
      aiLinkColor:      customColors?.aiLinkColor      || darken(0.047, aiMain),                           // #007db8  topic titles, cancel btn text

      // Surface backgrounds
      aiPanelBg:        customColors?.aiPanelBg        || desaturate(0.667, lighten(0.545, aiMain)),       // #EFF4F7  aside panel, history panel
      aiPanelIconBtnBg: customColors?.aiPanelIconBtnBg || desaturate(0.512, lighten(0.508, aiMain)),       // #DFEDF4  icon buttons, search box border
      aiChatBubbleBg:   customColors?.aiChatBubbleBg   || desaturate(0.20,  lighten(0.573, aiMain)),       // #F6FBFE  user prompt bubble

      // Source-link chip states
      aiSourceChipDefault: customColors?.aiSourceChipDefault || lighten(0.576, aiMain),                       // #F7FAFF  chip default bg
      aiSourceChipHover:   customColors?.aiSourceChipHover   || desaturate(0.231, lighten(0.541, aiMain)),    // #E8F4FC  chip hover bg
      aiSourceChipActive:  customColors?.aiSourceChipActive  || desaturate(0.406, lighten(0.467, aiMain)),    // #CCE5F2  chip active/open bg
      aiSourceChipBorder:  customColors?.aiSourceChipBorder  || desaturate(0.417, lighten(0.498, aiMain)),    // #D9EDF5  chip border
      aiTooltipBorder:     customColors?.aiTooltipBorder     || desaturate(0.667, lighten(0.492, aiMain)),    // #DDEAEE  tooltip card border
    },
    iconFont: 'purview-icons-v2',
    icons: {
      ...baseTheme.icons,
      ...purviewIconsV2,
      ...purviewIconsV2LegacyAliases,
      // ...purviewIconsV2ManualAliases,
    },
  };
}
